module.exports = __webpack_public_path__ + "img/fin.85bc7178.png";